module.exports = __webpack_public_path__ + "img/features-cloud-md.b527f04f.png";